import React from 'react';
import { Link } from 'react-router-dom';
const Button = ({ text, onClick, disabled, className, icon,href }) => {
  return (
    <Link to={href ? href : ""} className={`btn ${className?className:''}`} onClick={onClick} disabled={disabled}>
    	{icon}
      <span>{text}</span>
    </Link>
  );
};

export default Button;
